var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Warning",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-213.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-7",
    transform: "translate(33.000000, 165.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    transform: "translate(213.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9472136,2.34164079 C8.140741,2.43840449 8.29766349,2.59532698 8.39442719,2.78885438 L13.2763932,12.5527864 C13.5233825,13.0467649 13.3231581,13.6474379 12.8291796,13.8944272 C12.6903242,13.9638549 12.5372111,14 12.381966,14 L2.61803399,14 C2.06574924,14 1.61803399,13.5522847 1.61803399,13 C1.61803399,12.8447549 1.65417908,12.6916418 1.7236068,12.5527864 L6.60557281,2.78885438 C6.85256206,2.29487588 7.4532351,2.09465154 7.9472136,2.34164079 Z M8,12.0187308 L7,12.0187308 L7,13.0088394 L8,13.0088394 L8,12.0187308 Z M7.5,6 C7.22385763,6 7,6.20772963 7,6.46397712 L7,6.46397712 L7,10.1674548 L7.00805567,10.2508553 C7.05039163,10.4672999 7.25454011,10.631432 7.5,10.631432 C7.77614237,10.631432 8,10.4237023 8,10.1674548 L8,10.1674548 L8,6.46397712 L7.99194433,6.38057665 C7.94960837,6.16413206 7.74545989,6 7.5,6 Z",
    id: "Icons/16/Warning"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.bf92d7114beed7a4c32e1a6dfaec89af.svg";